import PrintReceivable from './receivable';

const routes = [
  {
    path: '/print/receivable/:id',
    component: PrintReceivable,
  },
];

export default routes;
